<template>
  <v-card flat>
    <v-toolbar flat>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer />
      <v-btn
        v-can="`${permissionPrefix}_Create`"
        color="primary"
        @click="openDialog()"
        >افزودن</v-btn
      >
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      item-key="id"
    >
      <template v-slot:item.id="{ index }">
        {{ index + 1 }}
      </template>
      <template v-slot:item.actions="{ item }"
        ><div class="d-flex align-center justify-center">
          <v-icon
            v-can="`${permissionPrefix}_Edit`"
            color="primary"
            @click="edit(item)"
            >mdi-pencil</v-icon
          >
          <v-icon
            v-can="`${permissionPrefix}_Delete`"
            color="red"
            @click="remove(item.id)"
            >mdi-delete</v-icon
          >
        </div>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="500">
      <v-card
        class="pa-4"
        style="border-radius: 12px; box-shadow: 0 10px 25px rgba(0,0,0,0.2);"
      >
        <v-card-title
          class="headline justify-center mb-2"
          style="font-family: IranSans, sans-serif !important"
        >
          {{ editedId ? "ویرایش" : "ایجاد" }}
        </v-card-title>

        <v-card-text style="padding-bottom: 0 !important;">
          <v-text-field label="نام" v-model="name" outlined dense clearable />
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn color="primary" dark rounded @click="save">ذخیره</v-btn>
          <v-btn text rounded @click="dialog = false">بستن</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import request from "@/utils/request";
import { hasPermission } from "@/composables/permissions";

export default {
  props: {
    title: String,
    api: String,
    permissionPrefix: String
  },
  data() {
    return {
      items: [],
      loading: false,
      dialog: false,
      name: "",
      editedId: null,
      headers: [
        { text: "شماره", value: "id" },
        { text: "نام", value: "name" },
        {
          text: "عملیات",
          value: "actions",
          sortable: false,
          align: "center",
          class: "actions"
        }
      ]
    };
  },
  mounted() {
    if (hasPermission(`${this.permissionPrefix}_View`)) this.load();
  },
  methods: {
    load() {
      this.loading = true;
      request.get(this.api).then(r => {
        this.items = r.data.result;
        this.loading = false;
      });
    },
    openDialog() {
      this.name = "";
      this.editedId = null;
      this.dialog = true;
    },
    edit(item) {
      this.name = item.name;
      this.editedId = item.id;
      this.dialog = true;
    },
    save() {
      const data = { name: this.name };
      const req = this.editedId
        ? request.put(`${this.api}/${this.editedId}`, data)
        : request.post(this.api, data);

      req.then(() => {
        this.dialog = false;
        this.load();
      });
    },
    remove(id) {
      this.$swal({
        title: "آیا مطمئن هستید؟",
        text: "بعد از حذف، اطلاعات قابل بازیابی نیست",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "حذف",
        cancelButtonText: "لغو"
      }).then(result => {
        if (result.isConfirmed) {
          request.delete(`${this.api}/${id}`).then(() => {
            this.load();
            this.$swal("حذف شد!", "آیتم با موفقیت حذف شد.", "success");
          });
        }
      });
    }
  }
};
</script>
